import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    viewBox='0 0 402 402'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      style={{
        fill: 'none',
      }}
      d='M1250.76 266.192h401.706v401.706H1250.76z'
      transform='translate(-1250.763 -266.192)'
    />
    <path
      d='M1611.62 628.581c.49-.095.87-.474.96-.959 2.42-13.069 31.48-181.821-63.96-277.257-59.12-59.127-155.13-59.127-214.25 0-59.13 59.126-59.13 155.132 0 214.259 95.43 95.436 264.18 66.379 277.25 63.957Zm-81.97-109.567c0 2.084-1.74 3.765-3.91 3.765h-52.97c-18.85 0-25.7 8.517-25.7 8.517l-1.27 1.727c-1.8 2.441-4.44.019-4.46.006l-1.22-1.524c-.9-1.086-7.82-8.729-24.58-8.729h-54.62c-2.15 0-3.9-1.684-3.9-3.765V406.328c0-2.081 1.75-3.765 3.9-3.765h42.4c31.54 0 34.53 17.916 34.74 23.121v78.366c0 5.696 2.71 6.766 4.24 6.922h2.28c1.56-.156 4.04-1.083 4.04-5.527v-80.772h-.02c.23-6.518 2.77-22.113 21.74-22.113h55.4c2.17 0 3.91 1.684 3.91 3.764v112.69Zm-256.73-89.961c5.15-34.08 20.83-66.868 47.05-93.085 26.21-26.217 59-41.9 93.08-47.049-68.78-10.89-130.31-.254-138 1.17-.49.095-.87.475-.96.96-1.43 7.686-12.06 69.216-1.17 138.004Z'
      style={{
        fill: '#0496ff',
      }}
      transform='translate(-1337.872 -288.84) scale(1.06609)'
    />
  </svg>
);

export default SvgComponent;
